var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTiempoIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tiempo",
    d: "M10.062.563a9.5,9.5,0,1,0,9.5,9.5A9.5,9.5,0,0,0,10.062.563ZM12.25,13.974,8.871,11.518a.463.463,0,0,1-.188-.372V4.7a.461.461,0,0,1,.46-.46h1.839a.461.461,0,0,1,.46.46V9.974l2.432,1.77a.459.459,0,0,1,.1.644l-1.08,1.486A.463.463,0,0,1,12.25,13.974Z",
    transform: "translate(-0.563 -0.563)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTiempoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tiempo_icon.406e281b.svg";
export { ForwardRef as ReactComponent };